import React from "react";

import { Box, CompassColor } from "@noom/wax-component-library";

type CheckboxProps = {
  checked?: boolean;
};

export const Checkbox: React.FC<CheckboxProps> = ({ checked }) => (
  <Box
    backgroundColor={CompassColor.white}
    border={`1px solid ${checked ? CompassColor.lagoon : CompassColor.sand02}`}
    borderRadius="4px"
    boxSizing="border-box"
    flexShrink={0}
    height="24px"
    marginRight="var(--spacing-m)"
    width="24px"
  >
    <svg
      fill="none"
      viewBox="0 0 10 8"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        height: "70%",
        width: "70%",
        margin: "15%",
        transform: checked ? "scale(1)" : "scale(0)",
        transition: "166ms transform ease-in-out",
      }}
    >
      <path
        d="M8.526.253L3.28 5.506 1.473 3.703a.863.863 0 10-1.22 1.223l2.418 2.412a.863.863 0 001.22-.002l5.857-5.863A.863.863 0 008.526.253z"
        fill="#05727a"
      />
    </svg>
  </Box>
);
